module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("配送加价规则")])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('div', [_c('el-form', {
    ref: "form",
    staticClass: "demo-dynamic",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "title",
      "label": "名称",
      "rules": [{
        required: true,
        message: '请输入名称'
      } ]
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "status",
      "label": "状态"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-text": "启用",
      "inactive-text": "禁用"
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  })], 1), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("范围规则  单位/km")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.addDomain('distance_rule')
      }
    }
  }, [_vm._v("新增+")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, _vm._l((_vm.form.distance_rule), function(item, index) {
    return _c('div', {
      key: item.key
    }, [_c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '起始距离',
        "prop": 'distance_rule.' + index + '.start',
        "rules": [{
          required: true,
          message: '起始距离不能为空'
        } ]
      }
    }, [_c('el-input', {
      attrs: {
        "size": "mini",
        "type": "text",
        "maxlength": "5",
        "show-word-limit": "",
        "placeholder": "请输入起始距离Km"
      },
      model: {
        value: (item.start),
        callback: function($$v) {
          _vm.$set(item, "start", $$v)
        },
        expression: "item.start"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '终止距离',
        "prop": 'distance_rule.' + index + '.end',
        "rules": [{
          required: true,
          message: '终止距离不能为空'
        } ]
      }
    }, [_c('el-input', {
      attrs: {
        "size": "mini",
        "type": "text",
        "maxlength": "5",
        "show-word-limit": "",
        "placeholder": "请输入终止距离Km"
      },
      model: {
        value: (item.end),
        callback: function($$v) {
          _vm.$set(item, "end", $$v)
        },
        expression: "item.end"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '加价金额',
        "prop": 'distance_rule.' + index + '.value',
        "rules": [{
          required: true,
          message: '加价金额不能为空'
        } ]
      }
    }, [_c('el-input', {
      attrs: {
        "size": "mini",
        "type": "text",
        "maxlength": "5",
        "show-word-limit": "",
        "placeholder": "请输入加价金额"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    })], 1), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeDomain(item, 'distance_rule')
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("重量规则 单位/kg")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addDomain('weigh_rule')
      }
    }
  }, [_vm._v("新增+")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, _vm._l((_vm.form.weigh_rule), function(item, index) {
    return _c('div', {
      key: item.key
    }, [_c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '起始重量',
        "prop": 'weigh_rule.' + index + '.start',
        "rules": [{
          required: true,
          message: '起始重量不能为空'
        } ]
      }
    }, [_c('el-input', {
      attrs: {
        "size": "mini",
        "type": "text",
        "maxlength": "5",
        "show-word-limit": "",
        "placeholder": "请输入起始重量Kg"
      },
      model: {
        value: (item.start),
        callback: function($$v) {
          _vm.$set(item, "start", $$v)
        },
        expression: "item.start"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '终止重量',
        "prop": 'weigh_rule.' + index + '.end',
        "rules": [{
          required: true,
          message: '终止重量不能为空'
        } ]
      }
    }, [_c('el-input', {
      attrs: {
        "size": "mini",
        "type": "text",
        "maxlength": "5",
        "show-word-limit": "",
        "placeholder": "请输入终止重量Kg"
      },
      model: {
        value: (item.end),
        callback: function($$v) {
          _vm.$set(item, "end", $$v)
        },
        expression: "item.end"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '加价金额',
        "prop": 'weigh_rule.' + index + '.value',
        "rules": [{
          required: true,
          message: '加价金额不能为空'
        } ]
      }
    }, [_c('el-input', {
      attrs: {
        "size": "mini",
        "type": "text",
        "show-word-limit": "",
        "maxlength": "5",
        "placeholder": "请输入加价金额"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    })], 1), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeDomain(item, 'weigh_rule')
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("时间规则")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addDomain('time_rule')
      }
    }
  }, [_vm._v("新增+")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, _vm._l((_vm.form.time_rule), function(item, index) {
    return _c('div', {
      key: item.key
    }, [_c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '起始时间',
        "prop": 'time_rule.' + index + '.start',
        "rules": [{
          required: true,
          message: '起始时间不能为空'
        } ]
      }
    }, [_c('el-time-select', {
      attrs: {
        "size": "mini",
        "picker-options": {
          start: '00:00',
          step: '00:01',
          end: '23:59'
        },
        "placeholder": "请输入起始时间"
      },
      model: {
        value: (item.start),
        callback: function($$v) {
          _vm.$set(item, "start", $$v)
        },
        expression: "item.start"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '终止时间',
        "prop": 'time_rule.' + index + '.end',
        "rules": [{
          required: true,
          message: '终止时间不能为空'
        } ]
      }
    }, [_c('el-time-select', {
      attrs: {
        "size": "mini",
        "picker-options": {
          start: '00:00',
          step: '00:01',
          end: '23:59'
        },
        "placeholder": "请输入终止时间"
      },
      model: {
        value: (item.end),
        callback: function($$v) {
          _vm.$set(item, "end", $$v)
        },
        expression: "item.end"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '加价金额',
        "prop": 'time_rule.' + index + '.value',
        "rules": [{
          required: true,
          message: '加价金额不能为空'
        } ]
      }
    }, [_c('el-input', {
      attrs: {
        "size": "mini",
        "type": "text",
        "maxlength": "5",
        "show-word-limit": "",
        "placeholder": "请输入加价金额"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    })], 1), _vm._v(" "), (index > 0) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeDomain(item, 'time_rule')
        }
      }
    }, [_vm._v("X")]) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("其他加价")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.addDomain('other_rule')
      }
    }
  }, [_vm._v("新增+")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, _vm._l((_vm.form.other_rule), function(item, index) {
    return _c('div', {
      key: item.key
    }, [_c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '描述',
        "prop": 'other_rule.' + index + '.name',
        "rules": [{
          required: true,
          message: '描述不能为空'
        } ]
      }
    }, [_c('el-input', {
      attrs: {
        "size": "mini",
        "type": "text",
        "placeholder": "请输入描述"
      },
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '开始时间',
        "prop": 'other_rule.' + index + '.start',
        "rules": [{
          required: true,
          message: '时间不能为空'
        } ]
      }
    }, [_c('el-date-picker', {
      attrs: {
        "value-format": "timestamp",
        "size": "mini",
        "type": "date",
        "placeholder": "选择日期"
      },
      model: {
        value: (item.start),
        callback: function($$v) {
          _vm.$set(item, "start", $$v)
        },
        expression: "item.start"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '结束时间',
        "prop": 'other_rule.' + index + '.end',
        "rules": [{
          required: true,
          message: '时间不能为空'
        } ]
      }
    }, [_c('el-date-picker', {
      attrs: {
        "value-format": "timestamp",
        "size": "mini",
        "type": "date",
        "placeholder": "选择日期"
      },
      model: {
        value: (item.end),
        callback: function($$v) {
          _vm.$set(item, "end", $$v)
        },
        expression: "item.end"
      }
    })], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "label": '加价金额',
        "prop": 'other_rule.' + index + '.value',
        "rules": [{
          required: true,
          message: '加价金额不能为空'
        } ]
      }
    }, [_c('el-input', {
      attrs: {
        "size": "mini",
        "type": "text",
        "maxlength": "5",
        "show-word-limit": "",
        "placeholder": "请输入加价金额"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          _vm.$set(item, "value", $$v)
        },
        expression: "item.value"
      }
    })], 1), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeDomain(item, 'other_rule')
        }
      }
    }, [_vm._v("X")])], 1)
  }), 0)]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit('form')
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('form')
      }
    }
  }, [_vm._v("重置")])], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e35f89cc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e35f89cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/merchant/freight/edit.vue
// module id = 2954
// module chunks = 0